/** @jsxImportSource @emotion/react */
import { Box } from '@mui/material'
import AppLoaderRefactored from '@app/routes/App/AppLoaderRefactored'
import { Suspense } from 'react'
import { appContainer, appContentContainer } from './BaseLayout.style'
import { ModalManager } from './ModalManager'
import { Sidebar } from '@app/components/ui/Sidebar/Sidebar'
import { Outlet } from 'react-router-dom'
import { FeatureFlagGate } from '@app/FeatureFlag/FeatureFlagGate'
import { FEATURE_FLAGS } from '@app/app-constants'

const BaseLayout = () => {
  return (
    <>
      <Box css={appContainer}>
        <Sidebar />
        <Box css={appContentContainer}>
          <Suspense fallback={null}>
            <Outlet />
          </Suspense>
        </Box>
      </Box>
      <Suspense fallback={null}>
        <ModalManager />
      </Suspense>
      <FeatureFlagGate flag={FEATURE_FLAGS.RISK_MODULE}>
        <AppLoaderRefactored />
      </FeatureFlagGate>
    </>
  )
}

export default BaseLayout
